import { NgxImageCompressService, DOC_ORIENTATION } from 'ngx-image-compress';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';
import { AggregatorService } from '@mpt-fo/common/core/services/aggregator.service';
import { Country, State } from '@mpt-fo/common/shared/models/business.model';
import { ConfigsModel, LocalGovernment } from '@mpt-fo/common/shared/models/configs.model';
import { ConfigService } from '@mpt-fo/common/core/services/config.service';
import { BaseFormComponent } from '@mpt-fo/common/lean-shared/components/base-form/base-form.component';
import { CustomFormControl, CustomFormControlDefinition } from '@mpt-fo/common/shared/utils/custom-form-control';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, Input, OnInit, inject } from '@angular/core';

@Component({
	selector: 'app-add-agent-location',
	templateUrl: './add-agent-location.component.html',
	styleUrls: ['./add-agent-location.component.scss']
})
export class AddAgentLocationComponent extends BaseFormComponent implements OnInit {

	@Input() agentId: number;
	withdrawalValueCommitment: CustomFormControlDefinition;
	locationName: CustomFormControlDefinition;
	estimatedFootFallPerHour: CustomFormControlDefinition;
	depositValueCommitment: CustomFormControlDefinition;
	addressLineOne: CustomFormControlDefinition;
	config: ConfigsModel;
	countries: Country[];
	states: State[];
	usedPlatforms: { name: any; }[];
	showSuccess: boolean;
	lgas: LocalGovernment[];
	modalData: any;

	fileName;
	fileSize;
	videoName;
	videoSize;
	fileSizeError: string;
	maxFileSize: number;
	callback: any;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(
		public fb: FormBuilder,
		private configService: ConfigService,
		private aggregatorService: AggregatorService,
		public modal: NzModalRef,
		private imageCompress: NgxImageCompressService
	) {
		super(fb);
		this.locationName = new CustomFormControl()
			.id('location')
			.placeholder('Location Name')
			.name('location')
			.isRequired()
			.build();

		this.estimatedFootFallPerHour = new CustomFormControl()
			.id('estimated-ffperHr')
			.placeholder('Estimated Foot fall Per Hour')
			.name('effph')
			.isCurrencyAmount()
			.build();

		this.depositValueCommitment = new CustomFormControl()
			.id('dep-val')
			.placeholder('Deposit Value Commitment')
			.name('dep-val')
			.isRequired()
			.isCurrencyAmount()
			.build();

		this.withdrawalValueCommitment = new CustomFormControl()
			.id('with-val')
			.placeholder('Withdrawal Value commitment')
			.name('with-val')
			.isRequired()
			.isCurrencyAmount()
			.build();

		this.addressLineOne = new CustomFormControl()
			.id('addy')
			.placeholder('Address')
			.name('addy')
			.isRequired()
			.build();

		this.form = fb.group({
			locationName: this.locationName.formGroupControl,
			estimatedFootFallPerHour: this.estimatedFootFallPerHour.formGroupControl,
			withdrawalValueCommitment: this.withdrawalValueCommitment.formGroupControl,
			depositValueCommitment: this.depositValueCommitment.formGroupControl,
			addressLineOne: this.addressLineOne.formGroupControl,
			listOfCurrentlyUsedPlatforms: [null, [Validators.required]],
			localGovernmentId: [null, [Validators.required]],
			locationPhysicallyVisitedByAggregator: [false],
			locationVideo: [null, [Validators.required]],
			endOfDayPicture: [null, [Validators.required]],
			state: [null, [Validators.required]],
		});

		this.configService.configObj.subscribe(res => {
			this.config = res;
			this.countries = this.config.countries;
			this.states = this.config.states;
			this.maxFileSize = this.config.multipartSizeLimitData.maxFileSize;
		});

		this.configService.usedPlatforms.subscribe(res => {
			this.usedPlatforms = res;
		});
	}

	ngOnInit(): void {
		if (this.modal) {
			this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		}
		this.modalData = this.modal?.componentInstance.data;
		this.callback = this.modal?.componentInstance.callback;
		this.form.get('state').valueChanges.subscribe(val => {
			if (!val) { return; }
			this.lgas = this.config.localGovernments.filter(x => x.state.id === val);
		});
	}

	addAgentLocation() {
		this.errorMessage = null;
		// if (this.validateForm()) { return; }
		if (this.fileSizeError) {
			return;
		}
		this.submittingForm = true;
		const formObj = this.form.value;
		formObj.locationVideo = formObj.locationVideo;
		formObj.endOfDayPicture = formObj.endOfDayPicture;
		if (!formObj.locationVideo) { delete formObj.locationVideo; }
		if (!formObj.endOfDayPicture) { delete formObj.endOfDayPicture; }
		delete formObj.state;
		formObj.agentId = this.modalData?.agentId;
		this.aggregatorService.addLocationToAgent(this.form.value).then(res => {
			this.submittingForm = false;
			this.showSuccess = true;
		}).catch(err => {
			this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(err);
			this.submittingForm = false;
		});
	}

	closeModal() {
		this.callback?.();
		this.modal?.destroy();
	}

	onFileChange(event, type: 'file' | 'video') {
		this.fileSizeError = null;
		const reader = new FileReader();

		if (event.target.files && event.target.files.length) {
			const [file] = event.target.files;
			const fileName = file.name;
			const fileSize = file.size;
			this[`${type}Name`] = fileName;
			this[`${type}Size`] = fileSize;
			reader.readAsDataURL(file);

			switch (type) {
				case 'file':
					reader.onload = () => {
						this.form.patchValue({
							endOfDayPicture: file
						});
					};
					break;
				case 'video':
					if (this.videoSize > this.maxFileSize) {
						this.fileSizeError = `File size shouldn't exceed ${this.maxFileSize}`;
						return;
					}
					reader.onload = () => {
						this.form.patchValue({
							locationVideo: file
						});
					};
					break;
			}
		}
	}

	compressFile(image, name) {
		this.imageCompress.compressFile(image, DOC_ORIENTATION.Up, 50, 50).then(
			result => {
				console.log('result from compression: ', result);
			}
		);
	}

}
